export function addedToCart(product) {
  //console.log('addedToCart')
  if (!window.klaviyo || !product) {
    return;
  }
    
  window.klaviyo.track('Added to Cart', product);
}

export function stockUpdateSubscribed(product) {
  if (!window.klaviyo || !product) return;

  window.klaviyo.track('Stock Update Subscribed', product);
}

export function viewedProduct(product) {
  if (!window.klaviyo || !product) return;

  window.klaviyo.track('Viewed Product', product);
  trackViewedItem(product)
}

function trackViewedItem(product) {
  if (!window.klaviyo || !product) return;
  
  window.klaviyo.trackViewedItem({
    Title: product.Name,
    ItemId: product.ProductID,
    Tags: product.Tags,
    ImageUrl: product.ImageURL,
    Url: product.URL,
    Metadata: {
      Brand: product.Brand,
      Price: product.Price,
      CompareAtPrice: product.CompareAtPrice
    }
  });
}